import { render } from "./AffiliateDetail.vue?vue&type=template&id=4ef57624&scoped=true"
import script from "./AffiliateDetail.js?vue&type=script&lang=js&external"
export * from "./AffiliateDetail.js?vue&type=script&lang=js&external"

import "./AffiliateDetail.scss?vue&type=style&index=0&id=4ef57624&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef57624"]])

export default __exports__